import React, { useState, useEffect } from 'react';

function Notification({ type, message, alertMsg }) {
  useEffect(() => {
    setTimeout(() => {
      alertMsg(false);
    }, 3000);
  });
  
  return (
    <div>
      {type === 'success' && (
        <div
          className="p-2 absolute bottom-0 bg-green-700 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
          style={{ zIndex: '999999' }}
          role="alert"
        >
          <span className="flex rounded-full bg-green-700 uppercase px-2 py-1 text-xs font-bold mr-3">New</span>
          <span className="font-semibold mr-2 text-left flex-auto">{message}</span>
        </div>
      ) }
      {type === 'error' && (
        <div
          className="p-2 absolute bottom-0 bg-red-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
          style={{ zIndex: '999999' }}
          role="alert"
        >
          <span className="flex rounded-full bg-red-500 uppercase px-2 py-1 text-xs font-bold mr-3">New</span>
          <span className="font-semibold mr-2 text-left flex-auto">{message}</span>
        </div>
      ) }
      {type === 'update' && (
        <div
          className="p-2 absolute bottom-0 bg-blue-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
          style={{ zIndex: '999999' }}
          role="alert"
        >
          <span className="flex rounded-full bg-blue-500 uppercase px-2 py-1 text-xs font-bold mr-3">New</span>
          <span className="font-semibold mr-2 text-left flex-auto">{message}</span>
        </div>
      )}
      {type === 'delete' && (
        <div
          className="p-2 absolute bottom-0 bg-red-100 items-center text-red-700 leading-none lg:rounded-full flex lg:inline-flex"
          style={{ zIndex: '999999' }}
          role="alert"
        >
          <span className="flex rounded-full bg-red-100 uppercase px-2 py-1 text-xs font-bold mr-3">New</span>
          <span className="font-semibold mr-2 text-left flex-auto">{message}</span>
        </div>
      )}
    </div>
  );
}
export default Notification;
